<!--<div class="example-config">
  Checked keys: {{checkedKeys.join(",")}}
</div>-->

<div *ngIf="showAllCheckBox">
  <input type="checkbox" (change)="allCheckClick()" [(ngModel)]="checkAll" kendoCheckBox
    [checked]="userLocationIds.length==checkedKeys.length" /> {{'_General_All_Text_' | translate }}
</div>
<kendo-treeview [nodes]="locations" textField="locationName" childrenField="items"
  [kendoTreeViewCheckable]="checkableSettings" [checkBy]="key" [(checkedKeys)]="checkedKeys"
  kendoTreeViewHierarchyBinding [filterable]=hasFilter filterInputPlaceholder="{{'_General_Search_Text_' | translate }}" kendoTreeViewExpandable
  [(expandedKeys)]="expandedKeys" [expandBy]="key" [loadOnDemand]="false">
</kendo-treeview>